import React from "react";

function Box({ checked, checked1, onChange, label, Highlight }) {
  return (
    <>
      <div className="border" onClick={() => onChange(!checked && !checked1)}>
        <div
          className={`indicator ${checked ? "checked" : ""} ${
            checked1 ? "checked" : ""
          }`}
        ></div>
      </div>
      <div className={`label ${Highlight ? "highlight" : ""} `}>{label}</div>
    </>
  );
}

export default Box;
